<template lang="pug">
  el-date-picker(
    v-model="inputModel[modelKey]"
    :type="type"
    :value-format="format"
    :picker-options="pickerOptions"
    :disabled="inputModel.disabled"
    :clearable="clearable"
    :size="size"
  )
</template>

<script>
export default {
  name: 'DateInput',
  props: {
    inputModel: { required: true },
    modelKey: { required: false, default: 'date' },
    type: { required: false, default: 'date' },
    clearable: { required: false, default: true },
    format: { required: false, default: 'yyyy-MM-dd' },
    options: { required: false },
    disabled: { required: false, default: false },
    size: { required: false, default: 'default' },
  },
  computed: {
    pickerOptions() {
      return { firstDayOfWeek: 1, ...this.options };
    },
  },
};
</script>
